import { render, staticRenderFns } from "./result-win-detail.vue?vue&type=template&id=21babab0&scoped=true&"
import script from "./result-win-detail.vue?vue&type=script&lang=js&"
export * from "./result-win-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21babab0",
  null
  
)

export default component.exports